"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUUIDV4 = exports.generateRandomId = void 0;
const uuid_1 = require("uuid");
const generateRandomId = () => {
    return (0, uuid_1.v4)();
};
exports.generateRandomId = generateRandomId;
const isValidUUIDV4 = (uuid) => {
    const REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return REGEX.test(uuid);
};
exports.isValidUUIDV4 = isValidUUIDV4;
